import styled from 'styled-components';

export const StyledHeaderActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  column-gap: 12px;
`;
